import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  Container,
  Card,
  CardBody,
  CardHeader,
  Spinner,
  Alert,
  Button,
  Row,
  Col,
  Badge,
  Progress
} from 'reactstrap';
import {
  ArrowLeft,
  User,
  Camera,
  Clock,
  MapPin,
  Shield,
  CheckCircle,
  XCircle,
  AlertTriangle,
  LogIn,
  LogOut,
  Award
} from 'react-feather';
import { FaRegBuilding } from "react-icons/fa";
import { BsGraphUpArrow } from "react-icons/bs";
import { BiCctv } from "react-icons/bi";
import { Entrycameramonitor } from "../../../../api/EntryCameraMonitorifl";
import Crash from './asset/Crash.png'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';




const ContractorDetails = () => {
  const { employeeId } = useParams();
  const location = useLocation()
  const location_blacklist = location?.state?.blacklisted
  const navigate = useNavigate();

  const [detail, setDetail] = useState(null);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

// ........................
  const [isBlacklistModalOpen, setIsBlacklistModalOpen] = useState(false);
const toggleBlacklistModal = () => setIsBlacklistModalOpen(!isBlacklistModalOpen);

const handleBlacklist = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const payload = {
      blacklisted: location_blacklist ? false : true,
      employee_id: employeeId,
    };

    const response = await Entrycameramonitor.blacklistToggle(payload);
    navigate(-1);


    
  } catch (error) {
    console.error("Blacklist error:", error);
    alert("An error occurred while blacklisting.");
  }
};

// ..........................

  // Debug logging
  console.log('ContractorDetails rendered');
  console.log('employeeId from params:', employeeId);
  console.log('Current URL:', window.location.pathname);


  const getLiveAlertData = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem('userData'));

      // Check if userData exists
      if (!userData || !userData.client?.id || !userData.factory?.id) {
        setError('User data not found. Please login again.');
        setLoading(false);
        return;
      }
      const payload1 = {
        client_id: userData.client.id,
        factory_id: userData.factory.id,
        camera_id: "",
        employee_id: employeeId,
        filters: {
          date: "",
          week: "",
          month: "2025-08",
          starting: "",
          ending: "",
        },
      }
      const payload = {
        client_id: userData.client.id,
        factory_id: userData.factory.id,
        limit: "1000",
        offset: 0,
        camera_id: "",
        employee_id: employeeId,
        filters: {
          date: "",
          week: "",
          month: "2025-08",
          starting: "",
          ending: "",
        },
      };

      const res = await Entrycameramonitor.getLiveAlertss(payload);
      const response = await Entrycameramonitor.getStats(payload1);

      if (res.status === 200 && res.data?.data?.logs) {
        const filtered = res.data.data.logs.find((e) => e.employee_id === employeeId);

        if (filtered) {
          setDetail(filtered);
        } else {
          // Create a placeholder detail object when no data is found
          setDetail({
            employee_id: employeeId,
            employee_name: null,
            employee_designation: null,
            face_image_url: null,
            camera_position_no: null,
            detection_datetime: null,
            camera_name: null,
            factory_name: null,
            blacklisted: false,
            sop_followed: false
          });
        }
      } else {
        setError('Failed to fetch data from server.');
      }

      if (response?.status === 200 && response?.data) {
        setStats(response.data);
      }
    } catch (err) {
      console.error('Error fetching contractor details:', err);
      setError('An error occurred while fetching data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (employeeId) {
      getLiveAlertData();
    } else {
      setError('Employee ID not provided.');
      setLoading(false);
    }
  }, [employeeId]);

  const formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return 'N/A';
    const date = new Date(dateTimeStr);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  const getStatusConfig = (detail) => {
    if (!detail || (!detail.employee_name && !detail.face_image_url)) {
      return {
        color: 'secondary',
        icon: AlertTriangle,
        text: 'No Data Available',
        bgColor: '#f8f9fa',
        borderColor: '#dee2e6'
      };
    }
    if (detail.blacklisted) {
      return {
        color: 'danger',
        icon: XCircle,
        text: 'Blacklisted',
        bgColor: '#fee2e2',
        borderColor: '#fecaca'
      };
    } else if (detail.sop_followed) {
      return {
        color: 'success',
        icon: CheckCircle,
        text: 'SOP Followed',
        bgColor: '#dcfce7',
        borderColor: '#bbf7d0'
      };
    } else {
      return {
        color: 'warning',
        icon: AlertTriangle,
        text: 'SOP Not Followed',
        bgColor: '#fef3c7',
        borderColor: '#fde68a'
      };
    }
  };

  if (loading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <div className="text-center">
          <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
          <div className="mt-3 text-muted">Loading contractor details...</div>
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-4">
        <Alert color="danger" className="border-0 shadow-sm">
          <div className="d-flex align-items-center">
            <AlertTriangle className="me-2" size={20} />
            <div>
              <h6 className="mb-1">Error</h6>
              <p className="mb-0">{error}</p>
            </div>
          </div>
        </Alert>
        <Button color="link" onClick={() => navigate(-1)} className="p-0">
          <ArrowLeft size={16} className="me-1" />
          Back to previous page
        </Button>
      </Container>
    );
  }

  // Check if we have actual data or just placeholder
  const hasActualData = detail && (detail.employee_name || detail.face_image_url || detail.detection_datetime);

  const statusConfig = getStatusConfig(detail);
  const StatusIcon = statusConfig.icon;
  const complianceRate = stats?.data ?
    ((stats.data.sop_followed / (stats.data.sop_followed + stats.data.sop_unfollowed)) * 100).toFixed(1) : 0;

  return (
    <Container fluid className="py-4 px-3">
      <div className="mb-4">
        <Button
          color="light"
          onClick={() => navigate(-1)}
          className="border shadow-sm d-flex align-items-center"
          style={{ borderRadius: '8px' }}
        >
          <ArrowLeft size={16} className="me-2" />
          Back
        </Button>
      </div>

      {/* No Data Available Banner */}
      {!hasActualData && (
        <Alert color="info" className="border-0 shadow-sm mb-4">
          <div className="d-flex align-items-center">
            <AlertTriangle className="me-2" size={20} />
            <div>
              <h6 className="mb-1">Limited Data Available</h6>
              <p className="mb-0">No detailed records found for Employee ID: {employeeId}. Showing available information with placeholder data.</p>
            </div>
          </div>
        </Alert>
      )}

      <Card className="border-0 shadow-lg" style={{ borderRadius: '16px', overflow: 'hidden' }}>
        {/* Header */}
        <CardHeader
          className="border-0 text-white position-relative"
          style={{
            background: '#1e67d6 ',
            padding: '2rem'
          }}
        >
          <Row className="align-items-center">
            <Col>
              <div className="d-flex align-items-center">

                <div>
                  <h3 className="mb-1 fw-bold">Contractor Detection Details</h3>
                  <p className="mb-0 opacity-75">Employee ID: {employeeId}</p>
                </div>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className="p-4">
          {/* Profile and Basic Info Section */}
          <Row className="g-4 mb-5">
            {/* Profile Image and Status */}
            <Col lg={4} className="text-center">
              <div className="position-relative d-inline-block mb-3">
                {imageLoading && detail?.face_image_url && (
                  <div
                    className="position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center rounded-3 shadow-lg border"
                    style={{
                      width: '220px',
                      height: '220px',
                      backgroundColor: '#f8f9fa',
                      zIndex: 1
                    }}
                  >
                    <div className="text-center">
                      <Spinner color="primary" style={{ width: "2rem", height: "2rem" }} />
                      <div className="mt-2 text-muted small">Loading image...</div>
                    </div>
                  </div>
                )}
                <img
                  src={detail?.face_image_url || Crash}
                  alt="Face Detection"
                  className="rounded-3 shadow-lg border"
                  style={{
                    width: '220px',
                    height: '220px',
                    objectFit: 'cover',
                    border: '4px solid #fff !important',
                    opacity: imageLoading && detail?.face_image_url ? 0 : 1
                  }}
                  onLoad={() => setImageLoading(false)}
                  onError={(e) => {
                    setImageLoading(false);
                    setImageError(true);
                    e.target.src = Crash; // ✅ Correct
                    e.target.alt = 'Image not available';
                  }}
                />
                <div
                  className="position-absolute bottom-0 end-0 rounded-circle d-flex align-items-center justify-content-center shadow-lg border border-white border-3"
                  style={{
                    width: '55px',
                    height: '55px',
                    backgroundColor: statusConfig.color === 'danger' ? '#dc3545' :
                      statusConfig.color === 'success' ? '#198754' :
                        statusConfig.color === 'secondary' ? '#6c757d' : '#ffc107'
                  }}
                >
                  <StatusIcon size={24} className="text-white" />
                </div>
              </div>

              <h4 className="fw-bold text-dark mb-2">{detail?.employee_name || 'N/A'}</h4>
              <p className="text-muted mb-3 fs-6">{detail?.employee_designation || 'N/A'}</p>

              <Badge
                color={statusConfig.color}
                className="px-4 py-2 fs-6 fw-medium"
                style={{
                  borderRadius: '20px',
                  background: statusConfig.color === 'danger' ? '#dc3545' :
                    statusConfig.color === 'success' ? '#198754' :
                      statusConfig.color === 'secondary' ? '#6c757d' : '#ffc107'
                }}
              >
                <StatusIcon size={16} className="me-2" />
                {statusConfig.text}
              </Badge>
            </Col>

            

            {/* Details Grid */}
            <Col lg={8}>
              <Row className="g-3">
                <Col md={6}>
                  <Card className="h-100 border-0 bg-light">
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center mb-2">
                        <div
                          className="me-3 d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10"
                          style={{ width: '40px', height: '40px' }}
                        >
                          <User size={18} />
                        </div>
                        <div className="flex-grow-1">
                          <small className="text-muted fw-medium d-block">Employee ID</small>
                          <h6 className="mb-0 fw-bold text-dark">{detail?.employee_id || 'N/A'}</h6>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col md={6}>
                  <Card className="h-100 border-0 bg-light">
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center mb-2">
                        <div
                          className="me-3 d-flex align-items-center justify-content-center rounded-circle bg-info bg-opacity-10"
                          style={{ width: '40px', height: '40px' }}
                        >
                          <BiCctv size={18} />
                        </div>
                        <div className="flex-grow-1">
                          <small className="text-muted fw-medium d-block">Camera Position</small>
                          {detail?.camera_position_no ? (
                            <Badge
                              color={detail.camera_position_no === "Gate In" ? "primary" : "success"}
                              className="fw-medium"
                            >
                              <MapPin size={14} className="me-1" />
                              {detail.camera_position_no}
                            </Badge>
                          ) : (
                            <h6 className="mb-0 fw-bold text-muted">N/A</h6>
                          )}
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col md={6}>
                  <Card className="h-100 border-0 bg-light">
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center mb-2">
                        <div
                          className="me-3 d-flex align-items-center justify-content-center rounded-circle bg-warning bg-opacity-10"
                          style={{ width: '40px', height: '40px' }}
                        >
                          <Clock size={18} />
                        </div>
                        <div className="flex-grow-1">
                          <small className="text-muted fw-medium d-block">Detection Time</small>
                          <h6 className="mb-0 fw-bold text-dark">{formatDateTime(detail?.detection_datetime)}</h6>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col md={6}>
                  <Card className="h-100 border-0 bg-light">
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center mb-2">
                        <div
                          className="me-3 d-flex align-items-center justify-content-center rounded-circle bg-secondary bg-opacity-10"
                          style={{ width: '40px', height: '40px' }}
                        >
                          <Camera size={18} />
                        </div>
                        <div className="flex-grow-1">
                          <small className="text-muted fw-medium d-block">Camera Name</small>
                          <h6 className="mb-0 fw-bold text-dark">{detail?.camera_name || 'N/A'}</h6>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                <Col md={12}>
                  <Card className="h-100 border-0 bg-light">
                    <CardBody className="p-3">
                      <div className="d-flex align-items-center mb-2">
                        <div
                          className="me-3 d-flex align-items-center justify-content-center rounded-circle bg-success bg-opacity-10"
                          style={{ width: '40px', height: '40px' }}
                        >
                          <FaRegBuilding size={18} />
                        </div>
                        <div className="flex-grow-1">
                          <small className="text-muted fw-medium d-block">Factory</small>
                          <h6 className="mb-0 fw-bold text-dark">{detail?.factory_name || 'N/A'}</h6>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                  <div className="text-end">
  <Button color="danger" onClick={toggleBlacklistModal}>
   {location_blacklist ? 'Remove from blacklist' : 'Mark as Blacklisted'} 
  </Button>

  <Modal isOpen={isBlacklistModalOpen} toggle={toggleBlacklistModal} centered>
    <ModalHeader toggle={toggleBlacklistModal}>
      Confirm
    </ModalHeader>
    <ModalBody>
      Are you sure you want to {location_blacklist ? "remove this employee from blacklist" : "blacklist this employee"}?
    </ModalBody>
    <ModalFooter>
      <Button color="danger" onClick={handleBlacklist}>
        {location_blacklist ? "Remove from Blacklist" : "Yes, Blacklist"}
      </Button>
      <Button color="secondary" onClick={toggleBlacklistModal}>
        Cancel
      </Button>
    </ModalFooter>
  </Modal>
</div>
              </Row>
            </Col>
          </Row>

          {/* Statistics Section */}
          {stats && stats.data && (
            <>
              <hr className="my-4" />
              <div className="mb-4">
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="me-3 d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10"
                    style={{ width: '50px', height: '50px' }}
                  >
                    <BsGraphUpArrow size={18} />
                  </div>
                  <div>
                    <h4 className="mb-1 fw-bold text-dark">Statistics Overview</h4>
                    <p className="mb-0 text-muted">Comprehensive activity and compliance metrics</p>
                  </div>
                </div>

                <Row className="g-3">
                  <Col xl={2} lg={3} md={4} sm={6}>
                    <Card className="border-0 shadow-sm h-100" style={{ backgroundColor: '#eff6ff', borderLeft: '4px solid #3b82f6' }}>
                      <CardBody className="text-center p-3">
                        <LogIn size={32} className="text-primary mb-2" />
                        <div className="display-6 fw-bold text-primary mb-1">{stats.data.total_entries || 0}</div>
                        <small className="text-muted fw-medium">Total Entries</small>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={2} lg={3} md={4} sm={6}>
                    <Card className="border-0 shadow-sm h-100" style={{ backgroundColor: '#fdf4ff', borderLeft: '4px solid #a855f7' }}>
                      <CardBody className="text-center p-3">
                        <LogOut size={32} className="mb-2" style={{ color: '#a855f7' }} />
                        <div className="display-6 fw-bold mb-1" style={{ color: '#a855f7' }}>{stats.data.total_exits || 0}</div>
                        <small className="text-muted fw-medium">Total Exits</small>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={2} lg={3} md={4} sm={6}>
                    <Card className="border-0 shadow-sm h-100" style={{ backgroundColor: '#f0fdf4', borderLeft: '4px solid #22c55e' }}>
                      <CardBody className="text-center p-3">
                        <CheckCircle size={32} className="text-success mb-2" />
                        <div className="display-6 fw-bold text-success mb-1">{stats.data.sop_followed || 0}</div>
                        <small className="text-muted fw-medium">SOP Followed</small>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={2} lg={3} md={4} sm={6}>
                    <Card className="border-0 shadow-sm h-100" style={{ backgroundColor: '#fffbeb', borderLeft: '4px solid #f59e0b' }}>
                      <CardBody className="text-center p-3">
                        <XCircle size={32} className="text-warning mb-2" />
                        <div className="display-6 fw-bold text-warning mb-1">{stats.data.sop_unfollowed || 0}</div>
                        <small className="text-muted fw-medium">SOP Unfollowed</small>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col xl={2} lg={3} md={4} sm={6}>
                    <Card className="border-0 shadow-sm h-100" style={{ backgroundColor: '#fef2f2', borderLeft: '4px solid #ef4444' }}>
                      <CardBody className="text-center p-3">
                        <AlertTriangle size={32} className="text-danger mb-2" />
                        <div className="display-6 fw-bold text-danger mb-1">{stats.data.total_unknown_alerts || 0}</div>
                        <small className="text-muted fw-medium">Alerts</small>
                      </CardBody>
                    </Card>
                  </Col>

                  {/* <Col xl={2} lg={3} md={4} sm={6}>
                    <Card className="border-0 shadow-sm h-100" style={{ backgroundColor: '#f8fafc', borderLeft: '4px solid #64748b' }}>
                      <CardBody className="text-center p-3">
                        <Award size={32} className="text-dark mb-2" />
                        <div className="display-6 fw-bold text-dark mb-1">{complianceRate}%</div>
                        <small className="text-muted fw-medium">Compliance Rate</small>
                        <Progress
                          value={complianceRate}
                          color={complianceRate >= 80 ? 'success' : complianceRate >= 60 ? 'warning' : 'danger'}
                          className="mt-2"
                          style={{ height: '4px' }}
                        />
                      </CardBody>
                    </Card>
                  </Col> */}
                </Row>
              </div>
            </>
          )}
        </CardBody>
      </Card>
    </Container>
  );
}

export default ContractorDetails;